import { render, staticRenderFns } from "./InputError.vue?vue&type=template&id=10395371&scoped=true&"
import script from "./InputError.vue?vue&type=script&lang=js&"
export * from "./InputError.vue?vue&type=script&lang=js&"
import style0 from "./InputError.vue?vue&type=style&index=0&id=10395371&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10395371",
  null
  
)

export default component.exports